export enum AssetContainerEventType {
  Arrived = 'Arrived',
  Loading = 'Loading',
  LoadingComplete = 'Loading Complete',
  Unloading = 'Unloading',
  UnloadingComplete = 'Unloading Complete',
  ReadyForPickup = 'Ready for Pickup',
  Departed = 'Departed',
  Inoperable = 'Inoperable',
  Missing = 'Missing',
  InTransit = 'In Transit'
}

/**
 * Event types a client may set, and the single source for both the create-event validator and its
 * published Swagger enum. Listed explicitly rather than derived by excluding `InTransit`, so a new
 * event type stays client-unsettable until someone deliberately adds it here.
 */
export const CLIENT_SETTABLE_ASSET_CONTAINER_EVENT_TYPES: readonly AssetContainerEventType[] =
  Object.freeze([
    AssetContainerEventType.Arrived,
    AssetContainerEventType.Loading,
    AssetContainerEventType.LoadingComplete,
    AssetContainerEventType.Unloading,
    AssetContainerEventType.UnloadingComplete,
    AssetContainerEventType.ReadyForPickup,
    AssetContainerEventType.Departed,
    AssetContainerEventType.Inoperable,
    AssetContainerEventType.Missing
  ]) as readonly AssetContainerEventType[];

export interface IAssetContainerEvent {
  id: string;
  createDateTime: Date;
  createdBy?: string | null;
  orgId: string;
  assetContainerId: string;
  assetVisitId?: string | null;
  eventType: AssetContainerEventType;
}
